

export const frontMatter = {
	sidebar_position: 7,
	license: 'republish',
	author: 'Jan van Steenbergen',
	custom_edit_url: '/501',
	last_update: {
		author: 'Google Translate'
	},
	origin: 'http://steen.free.fr/interslavic/prepositions.html'
};
export const contentTitle = 'Сполучники';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-i-18-n-uk-docusaurus-plugin-content-docs-current-learn-grammar-conjunctions-md-e85.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    br: "br",
    code: "code",
    em: "em",
    h1: "h1",
    header: "header",
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {CustomAfterSection, TransliteratorElement} = _components;
  if (!CustomAfterSection) _missingMdxReference("CustomAfterSection", true);
  if (!TransliteratorElement) _missingMdxReference("TransliteratorElement", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "сполучники",
        children: "Сполучники"
      })
    }), "\n", _jsx(_components.p, {
      children: "Більшість прийменників у Слов’янському керують родовим відмінком. Це особливо вірно для всіх прийменників, які були похідними від іменників, прикметників або прислівників. У випадку прийменників, що стосуються місця та часу, наступне можна вважати орієнтиром, хоча є винятки:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "родовий відмінок"
        }), " вживається, коли вказується переміщення з/з місця."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "знахідний відмінок"
        }), " вживається, коли вказується рух до/в локацію;"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "орудний"
        }), " або ", _jsx(_components.strong, {
          children: "локативний відмінок"
        }), " використовується, коли локація є стабільною, тобто взагалі немає руху."]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "Прийменники слід використовувати лише відповідно до їх логічного значення, а не відповідно до національних ідіом. Ось список прийменників слов’янською:"
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "З родовим відмінком"
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(TransliteratorElement, {
        children: "bez"
      }), " – без", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "blizko"
      }), " – поблизу, поблизу", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "dlja"
      }), " – для", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "do"
      }), " – до, до, до", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "iz"
      }), " – з, з", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "iz-medžu"
      }), " – з між", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "iz-nad"
      }), " – зверху", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "iz-pod"
      }), " – з-під", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "iz-prěd"
      }), " – раніше", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "iz-srěd"
      }), " – з числа", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "iz-za"
      }), " – ззаду", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "kolo"
      }), " – поруч, навколо", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "kromě"
      }), " – крім", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "mimo"
      }), " – минуле, від", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "naprotiv"
      }), " – навпроти", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "od"
      }), " – з, з (подалі від); оскільки; від (агент)", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "odnosno"
      }), " – щодо, про", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "okolo"
      }), " – навколо; приблизно, приблизно"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(TransliteratorElement, {
        children: "podčas"
      }), " – під час, поки", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "podle"
      }), " – поруч, поруч", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "pomimo"
      }), " – незважаючи на", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "poprěk"
      }), " – через", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "pored"
      }), " – поруч", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "poslě"
      }), " – після", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "posrěd"
      }), " – посеред, посеред, серед", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "posrědstvom"
      }), " – за допомогою, використовуючи", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "povrh"
      }), " – до верхньої сторони, зверху", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "srěd"
      }), " – серед, серед", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "suprotiv"
      }), " – всупереч", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "u"
      }), " – на, на місці", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "vdolž"
      }), " – уздовж", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "vměsto"
      }), " – замість", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "vně"
      }), " – за межами", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "vnutri"
      }), " – всередині, в межах", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "vslěd"
      }), " – після, через, в результаті", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "za"
      }), " – під час, у часи"]
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "З давальним відмінком"
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(TransliteratorElement, {
        children: "blagodare, dekujuči, hvala"
      }), " – дякую", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "k"
      }), " – до, у напрямку (напрямок)", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "po"
      }), " – згідно, за, шляхом, у порядку; за ... кожен, за ... шматочок"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(TransliteratorElement, {
        children: "protiv"
      }), " – проти", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "soglasno, suglasno"
      }), " – згідно"]
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "З знахідним відмінком"
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(TransliteratorElement, {
        children: "črěz, prěz"
      }), " – через, через, через", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "po"
      }), " – для (в гонитві за, отримати щось); за (X-й раз); аж до"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(TransliteratorElement, {
        children: "za"
      }), " – за, через, завдяки, в обмін на, на користь, замість"]
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "З інструменталом"
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(TransliteratorElement, {
        children: "ponad"
      }), " – вище, поза"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(TransliteratorElement, {
        children: "s, so"
      }), " – з, разом з; за допомогою, використовуючи"]
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "З місцем розташування"
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(TransliteratorElement, {
        children: "o, ob"
      }), " – приблизно; щодо, щодо", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "po"
      }), " – після, після; уздовж (збоку); скрізь, навколо, по всьому"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(TransliteratorElement, {
        children: "pri"
      }), " – близько; під час (правління короля)"]
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "З знахідним та орудним відмінком"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Наступні п’ять прийменників стосуються місця та (якщо застосовно) часу. Орудний відмінок вживається, коли локація стабільна (", _jsx(TransliteratorElement, {
        children: "Kot spi pod stolom"
      }), " – «Кіт спить під столом»), акузатив виражає рух до нього (", _jsx(TransliteratorElement, {
        children: "Kot poběgl pod stol"
      }), " – «Кіт утік під стіл»).", _jsx(_components.br, {}), "\n", "Прийменник ", _jsx(TransliteratorElement, {
        children: "za"
      }), " також можна вживати з родовим і (в інших значеннях) знахідним, але оскільки в інших випадках він належить до тієї ж категорії, що й інші, його зазначено тут окремо."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(TransliteratorElement, {
        children: "medžu"
      }), " – між (місце та час)", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "nad"
      }), " – вище, понад, поза", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "pod"
      }), " – під"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(TransliteratorElement, {
        children: "prěd"
      }), " – перед, перед, перед (місце та час), до, перед", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "za"
      }), " – позаду (місце), після (час)"]
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "З знахідним і місцевим відмінками"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Прийменники ", _jsx(_components.code, {
        children: "v"
      }), " і ", _jsx(TransliteratorElement, {
        children: "na"
      }), " діють так само, як і попередня категорія, за винятком того, що для стабільного розташування замість інструменталю використовується місцевий."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(TransliteratorElement, {
        children: "na"
      }), " (", _jsxs(_components.em, {
        children: ["+ ", _jsx(TransliteratorElement, {
          children: "loc"
        }), "."]
      }), ") – на, при; (", _jsxs(_components.em, {
        children: ["+ ", _jsx(_components.code, {
          children: "acc"
        }), "."]
      }), ") – на(до), до"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(TransliteratorElement, {
        children: "v, vo"
      }), " (", _jsxs(_components.em, {
        children: ["+ ", _jsx(TransliteratorElement, {
          children: "loc"
        }), "."]
      }), ") – всередині; (", _jsxs(_components.em, {
        children: ["+ ", _jsx(_components.code, {
          children: "acc"
        }), "."]
      }), ") – в"]
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "Прийменникові конструкції"
      })
    }), "\n", _jsx(_components.p, {
      children: "Наступні комбінації не є справжніми прийменниками, але використовуються як такі та часто перекладаються як прийменники. Перелік, звичайно, далеко не вичерпний."
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(TransliteratorElement, {
        children: "bez obzira na"
      }), " (", _jsxs(_components.em, {
        children: ["+ ", _jsx(_components.code, {
          children: "acc"
        }), "."]
      }), ") – незалежно", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "čto se tyče"
      }), " (", _jsxs(_components.em, {
        children: ["+ ", _jsx(_components.code, {
          children: "gen"
        }), "."]
      }), ") – щодо, щодо", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "na prěkor"
      }), " (", _jsxs(_components.em, {
        children: ["+ ", _jsx(_components.code, {
          children: "gen"
        }), "."]
      }), ") – всупереч", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "ne gledajuči na"
      }), " (", _jsxs(_components.em, {
        children: ["+ ", _jsx(_components.code, {
          children: "acc"
        }), "."]
      }), ") – нехтуючи, незважаючи на, незважаючи на, незважаючи", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "od strany"
      }), " (", _jsxs(_components.em, {
        children: ["+ ", _jsx(_components.code, {
          children: "gen"
        }), "."]
      }), ") – від, з боку", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "po odnošenju k"
      }), " (", _jsxs(_components.em, {
        children: ["+ ", _jsx(TransliteratorElement, {
          children: "dat"
        }), "."]
      }), ") – щодо, щодо", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "pod vodstvom"
      }), " (", _jsxs(_components.em, {
        children: ["+ ", _jsx(_components.code, {
          children: "gen"
        }), "."]
      }), ") – під керівництвом", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "s izključenjem"
      }), " (", _jsxs(_components.em, {
        children: ["+ ", _jsx(_components.code, {
          children: "gen"
        }), "."]
      }), ") – крім, за винятком", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "s obzirom na"
      }), " (", _jsxs(_components.em, {
        children: ["+ ", _jsx(_components.code, {
          children: "acc"
        }), "."]
      }), ") – щодо", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "s pomočju"
      }), " (", _jsxs(_components.em, {
        children: ["+ ", _jsx(_components.code, {
          children: "gen"
        }), "."]
      }), ") – за допомогою", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "sgodno s"
      }), " (", _jsxs(_components.em, {
        children: ["+ ", _jsx(_components.code, {
          children: "inst"
        }), "."]
      }), ") – відповідати", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "susedno do"
      }), " (", _jsxs(_components.em, {
        children: ["+ ", _jsx(_components.code, {
          children: "gen"
        }), "."]
      }), ") – поруч, сусідній з"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(TransliteratorElement, {
        children: "v času"
      }), " (", _jsxs(_components.em, {
        children: ["+ ", _jsx(_components.code, {
          children: "gen"
        }), "."]
      }), ") – протягом", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "v imenu"
      }), " (", _jsxs(_components.em, {
        children: ["+ ", _jsx(_components.code, {
          children: "gen"
        }), "."]
      }), ") – від імені", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "v obličju"
      }), " (", _jsxs(_components.em, {
        children: ["+ ", _jsx(_components.code, {
          children: "gen"
        }), "."]
      }), ") – в особі", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "v odrazlikě od"
      }), " (", _jsxs(_components.em, {
        children: ["+ ", _jsx(_components.code, {
          children: "gen"
        }), "."]
      }), ") – на відміну від", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "v odnošenju k"
      }), " (", _jsxs(_components.em, {
        children: ["+ ", _jsx(TransliteratorElement, {
          children: "dat"
        }), "."]
      }), ") – щодо, щодо", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "v ramah, v ramkah"
      }), " (", _jsxs(_components.em, {
        children: ["+ ", _jsx(_components.code, {
          children: "gen"
        }), "."]
      }), ") – в рамках, у складі", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "v protivnosti k"
      }), " (", _jsxs(_components.em, {
        children: ["+ ", _jsx(TransliteratorElement, {
          children: "dat"
        }), "."]
      }), ") – на відміну від, на противагу", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "v smyslu"
      }), " (", _jsxs(_components.em, {
        children: ["+ ", _jsx(_components.code, {
          children: "gen"
        }), "."]
      }), ") – у значенні", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "v različju od"
      }), " (", _jsxs(_components.em, {
        children: ["+ ", _jsx(_components.code, {
          children: "gen"
        }), "."]
      }), ") – на відміну від", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "v svezi s"
      }), " (", _jsxs(_components.em, {
        children: ["+ ", _jsx(_components.code, {
          children: "inst"
        }), "."]
      }), ") – у зв’язку з", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "v těčenju"
      }), " (", _jsxs(_components.em, {
        children: ["+ ", _jsx(_components.code, {
          children: "gen"
        }), "."]
      }), ") – протягом", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "v vrěmenu"
      }), " (", _jsxs(_components.em, {
        children: ["+ ", _jsx(_components.code, {
          children: "gen"
        }), "."]
      }), ") – протягом", _jsx(_components.br, {}), "\n", _jsx(TransliteratorElement, {
        children: "v zaměn za"
      }), " (", _jsxs(_components.em, {
        children: ["+ ", _jsx(_components.code, {
          children: "acc"
        }), "."]
      }), ") – замість, в обмін на"]
    }), "\n", _jsxs(_components.p, {
      children: ["Багато прийменників також можна використовувати як префікси. Докладніше див. ", _jsx(_components.a, {
        href: "/uk/learn/vocabulary/word-formation#prefixes",
        children: "словотворення"
      }), "."]
    }), "\n", _jsx(CustomAfterSection, {})]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}

